<template>
    <div>
      <h2>Paramètres</h2>
      <p>Modifier vos préférences ici.</p>
    </div>
  </template>
  